module.exports = __webpack_public_path__ + "static/super-transparent-3984014b8005ba510d95f4f761b227cb.gif";